<mat-form-field *ngIf="options?.length" id="select-field" appearance="outline">
  <mat-label>{{ label }}</mat-label>
  <mat-select [value]="value || ''" (valueChange)="value = $event">
    <mat-option *ngFor="let option of options" [value]="option.value" [disabled]="option.disabled">
      <span [innerHTML]="option.label | safe: 'html'"></span>
    </mat-option>
  </mat-select>
</mat-form-field>
